import React from 'react';
import { useHistory } from 'react-router-dom';
import { Navbar, Button } from 'react-bootstrap';
import { clearLocalStorage } from '../utils/localStorage';

type Props = any;
const Nav: React.FC<Props> = () => {
  let history = useHistory();

  return (
    <Navbar bg="dark" variant="dark">
      <Navbar.Brand
        onClick={() => history.goBack()}
        style={{ cursor: 'pointer' }}
      >
        Support Desk
      </Navbar.Brand>
      <Navbar.Collapse className="justify-content-end">
        <Button variant="outline-light" onClick={clearLocalStorage}>
          Log Out
        </Button>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default Nav;
